import { mapRecordFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetOneResponse } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import {
  IQuotesDashboardDetails,
  IQuotesDashboardSummary,
  IQuotesDashboardSummaryRequestPayload,
} from 'reports/types';

export const getQuotesDashboardSummary = async (
  requestPayload: IQuotesDashboardSummaryRequestPayload,
  signal?: AbortSignal
): Promise<GetOneResponse<IQuotesDashboardSummary>> => {
  const { data } = await partfinitiClient.get(
    `/quote/dashboard/summary?${getQueryStringToSnakeCase(requestPayload, {
      removeNullValues: true,
    })}`,
    signal
  );

  return mapRecordFromServer<IQuotesDashboardSummary>(data.data);
};

export const getQuotesDashboardDetails = async (
  requestPayload: IQuotesDashboardSummaryRequestPayload,
  signal?: AbortSignal
): Promise<GetOneResponse<IQuotesDashboardDetails>> => {
  const { data } = await partfinitiClient.get(
    `/quote/dashboard/details?${getQueryStringToSnakeCase(requestPayload, {
      removeNullValues: true,
    })}`,
    signal
  );

  return mapRecordFromServer<IQuotesDashboardDetails>(data.data);
};
